import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { SentryService } from '../_services/error-reporter.service';

const IGNORED_STATUS_CODES = [401, 403, 429];

export const sentryInterceptor: HttpInterceptorFn = (req, next) => {
  const sentry = inject(SentryService);

  return next(req).pipe(
    tap({
      error: (error) => {
        if (!(error instanceof HttpErrorResponse)) return;

        if (IGNORED_STATUS_CODES.includes(error.status)) return;
        if (error.status === 0) return;

        sentry.captureException(
          new Error(`HTTP ${error.status} ${req.method} ${req.urlWithParams}`),
          {
            context: 'http_request',
            method: req.method,
            url: req.urlWithParams,
            status: error.status,
            statusText: error.statusText,
            serverMessage: error.error?.message ?? '',
          }
        );
      },
    })
  );
};
